import { HStack, VStack } from "@gluestack-ui/themed";
import { BottomBarProps } from "./types";
import { BottomBarItem } from "./components/BottomBarItem";
import { useBottomBarController } from "./controller";
import { CanView } from "@repo/core/components/core/CanView";

export const BottomBar = ({ items, onItemPress }: BottomBarProps) => {
  const { handlerItemPress, selected } = useBottomBarController({
    onItemPress,
    items
  });

  return (
    <VStack
      bg={"$white"}
      borderTopWidth={1}
      borderColor="$borderLight200"
      flex={1}
      w="$full"
      px="$2"
    >
      <HStack justifyContent="space-around" overflow="hidden" h="$16">
        {items?.map((item) => (
          <CanView permissions={item.permissions}>
            <BottomBarItem
              key={item.key}
              icon={item.icon}
              label={item.label}
              isSelected={selected?.key === item.key}
              onPress={() => handlerItemPress(item)}
            />
          </CanView>
        ))}
      </HStack>
    </VStack>
  );
};
